import { IncomingMessage } from 'http';

import { QueryFunction, QueryKey } from '@tanstack/react-query';

import { searchProducts } from '../../../services/products/search';

const getProducts = (
  options: {
    locale: string;
    partIdentifier: string;
    carIdentifier: string;
    page: string;
    sort: string;
    reference: string;
    min_price: string;
    max_price: string;
    detailed_prices?: string;
  },
  req?: IncomingMessage
): [QueryKey, QueryFunction<ReturnType<typeof searchProducts>>] => [
  ['user-dependent', 'products', options],
  ({
    queryKey: [, , key],
  }: {
    queryKey: [
      string,
      string,
      {
        locale: string;
        partIdentifier: string;
        carIdentifier: string;
        sort: string;
        page: string;
        reference: string;
        min_price: string;
        max_price: string;
        detailed_prices?: string;
      }
    ];
  }) => searchProducts(key, req),
];

export default getProducts;
